import React, { createContext, useContext, useState, ReactNode } from 'react'
import { CommunityQuestion } from './types/index' // Adjust path as needed

interface CommunityQuestionContextType {
    selectedCommunityQuestion: CommunityQuestion | null
    setSelectedCommunityQuestion: (question: CommunityQuestion | null) => void
}

const CommunityQuestionContext = createContext<
    CommunityQuestionContextType | undefined
>(undefined)

interface CommunityQuestionProviderProps {
    children: ReactNode
}

export const CommunityQuestionProvider: React.FC<
    CommunityQuestionProviderProps
> = ({ children }) => {
    const [selectedCommunityQuestion, setSelectedCommunityQuestion] =
        useState<CommunityQuestion | null>(null)

    const value = {
        selectedCommunityQuestion,
        setSelectedCommunityQuestion,
    }

    return (
        <CommunityQuestionContext.Provider value={value}>
            {children}
        </CommunityQuestionContext.Provider>
    )
}

// Custom hook for using the context
export const useCommunityQuestion = () => {
    const context = useContext(CommunityQuestionContext)
    if (context === undefined) {
        throw new Error(
            'useCommunityQuestion must be used within a CommunityQuestionProvider'
        )
    }
    return context
}
